<template>
  <div class="cotainer card-item">
    <div class="card-title">
      <div class="title-box">
        <span class="title-text">品牌建设</span>
      </div>
      <div class="title-boxs">
        <span class="btn-action-group">
          <a-button
            type="primary"
            v-if="(oldInfos?.id && isRevise) || !isScore"
            @click="addGains"
            class="btn-action"
            >新增</a-button
          >
          <!-- <a-button
            class="btn-action"
            type="primary"
            v-if="oldInfos?.id"
            @click="showevidence"
          >
            佐证材料</a-button
          > -->

          <!-- <a-button
            @click="importsj()"
            class="btn-action"
            v-if="(oldInfos?.id && isRevise) || !isScore"
            >导入</a-button
          > -->
          <a-button
            class="btn-action"
            danger
            v-if="(oldInfos?.id && isRevise) || !isScore"
            type="text"
            @click="batchDelete"
          >
            批量移除</a-button
          >
        </span>
      </div>
    </div>

    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{ emptyText }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :scroll="{ y: 290 }"
        :row-selection="rowSelection"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template slot="sex" slot-scope="text, record, index">
          <span v-if="text == '1'">男</span>
          <span v-else>女</span>
        </template>
        <template slot="izResponse" slot-scope="text, record, index">
          <span v-if="text == '1'">是</span>
          <span v-else>否</span>
        </template>
        <template slot="type" slot-scope="text, record">
          <span v-if="text == '其他'">{{ record.otherType }}</span>
          <span v-else>{{ text }}</span>
        </template>
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 50px"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && !isEdit) || isScore"
            @click="showevidence(record)"
          >
            <img class="img-box" src="../../assets/images/imgcl.png" alt="" />
            <span>佐证材料</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record)"
            v-if="(oldInfos && oldInfos.id && isRevise) || !isScore"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record)"
            v-if="(oldInfos && oldInfos.id && isRevise) || !isScore"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && !isRevise) || isScore"
            @click="seeInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>查看</span>
          </div>
        </span>
      </a-table>
    </div>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要移除该条团队建设的数据吗?</p>
    </a-modal>
    <!-- 添加团队建设 -->
    <AddTeamBuild ref="addGain" @addGain="addGaincz"></AddTeamBuild>
    <data-import ref="dataImport" @refreshData="addGain"></data-import>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :isEdit="isEdit"
          :id="id"
          :dataid="sj.id"
          @closePreview="showtable = false"
        >
        </evidencelist>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import AddTeamBuild from "./addBrandBuild.vue";
import evidencelist from "@/components/common/evidencelist";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "年份",
    dataIndex: "constructionYear",
    id: "constructionYear",
    align: "center",
    width: 150,
  },
  {
    title: "名称",
    dataIndex: "name",
    id: "name",
    align: "center",
  },
  {
    title: "类别",
    dataIndex: "type",
    id: "type;",
    align: "center",
    scopedSlots: { customRender: "type" },
  },
  {
    title: "数量",
    dataIndex: "num",
    id: "num",
    align: "center",
    width: 100,
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 350,
    scopedSlots: { customRender: "action" },
  },
];

export default {
  data() {
    return {
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      selectedRowKeys: [],
      isEdit: false,
      emptyText: "暂无数据",
      showtable: false,
      id: "",
      title: "",
      sj: {},
      isScore: false,
    };
  },
  watch: {
    "oldInfos.brandBuildlist": {
      handler(newValue, oldValue) {
        console.log(newValue, "oldInfos.brandBuildlist");
        if (newValue != null) {
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.emptyText = "暂无数据";
          this.addGain();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
    },
    isRevise: {
      handler(newValue, oldValue) {
        // console.log(newValue,'我是')
        this.isEdit = !newValue;
      },
      immediate: true,
    },
  },
  props: {
    oldInfos: {
      type: Object,
    },
    isRevise: {
      type: Boolean,
    },
  },
  components: {
    AddTeamBuild,
    dataImport,
    evidencelist,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        // 其他 row-selection 的配置
      };
    },
  },
  mounted() {
    this.isScore =
      this.$store.state.role === "score-role" ||
      this.$store.state.role === "education-role" ||
      this.$store.state.role === "education-guide-role";
    if (!this.oldInfos?.id) {
      this.emptyText = "填写基本信息之后才能添加内容";
    }
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    //this.getData();
    this.addGain();
  },
  methods: {
    showevidence(record) {
      this.title = "品牌建设";
      this.id = this.oldInfos.id;
      this.sj = record;
      this.showtable = true;
    },
    importsj() {
      this.$refs.dataImport.init("brandCons", this.oldInfos, "品牌建设");
    },
    handleOk() {
      if (this.oldInfos?.id) {
        this.$message.success("移除成功");
        this.showDeleteModel = false;
        this.oldInfos.brandlist = this.oldInfos.brandlist.filter(
          (item) => item.id != this.deteleId
        );
        sessionStorage.setItem("pp1", JSON.stringify(this.oldInfos));
        this.getData();
      } else {
        this.$message.success("移除成功");
        this.showDeleteModel = false;
        this.oldInfos.brandBuildlist = this.oldInfos.brandBuildlist.filter(
          (item) => item.id != this.deteleId
        );
        sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
        this.getData();
      }
      // deleteAction("/promotion/lxApplyConstruction/delete", {
      //   id: this.deteleId,
      //   applyId: this.oldInfos?.id,
      // }).then((res) => {
      //   if (res.code == 200) {
      //     this.$message.success("移除成功");
      //     this.showDeleteModel = false;
      //     this.getData();
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
    },
    addGains() {
      this.$refs.addGain.init("add", this.oldInfos);
    },
    seeInfo(row) {
      this.$refs.addGain.init("see", row);
    },
    addGain() {
      // this.pagination.current = 1;
      this.getData();
    },
    addGaincz(sj) {
      if (this.oldInfos?.id) {
        this.addGain();
      } else {
        // this.pagination.current = 1;
        if (sj.type == "add") {
          // sj.record.id = sj.record.num + this.oldInfos.brandBuildlist.length;
          // this.oldInfos.brandBuildlist.push(sj.record);
          this.pagination.current = 1;
          sj.record.id = sj.record.num + this.oldInfos.brandBuildlist.length;
          this.oldInfos.brandBuildlist.unshift({
            ...sj.record,
            id: sj.record.num + (this.oldInfos.brandBuildlist.length + 1),
          });
        } else {
          let index = this.oldInfos.brandBuildlist.findIndex(
            (item) => item.id === sj.record.id
          );
          // console.log(sj.record.id,this.oldInfos.brandBuildlist);
          if (index !== -1) {
            // 如果找到相同的 id，替换该对象
            this.oldInfos.brandBuildlist[index] = sj.record;
          }
        }
        sessionStorage.setItem("pp1", JSON.stringify(this.oldInfos));
        this.getData();
      }
    },
    addGain() {
      // this.pagination.current = 1;
      this.getData();
    },
    getData() {
      console.log(this.oldInfos, "品牌建设");
      if (this.oldInfos?.id) {
        this.loading = true;
        let data = {
          applyType: 2,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/promotion/lxApplyConstruction/list", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      } else {
        if (
          this.oldInfos &&
          this.oldInfos.brandBuildlist &&
          this.oldInfos.brandBuildlist.length > 0
        ) {
          this.pagination.total = this.oldInfos.brandBuildlist.length;
          const startIndex =
            (this.pagination.current - 1) * this.pagination.pageSize;
          const endIndex = startIndex + this.pagination.pageSize;
          // this.dataList = this.oldInfos.brandBuildlist.slice(
          //   startIndex,
          //   endIndex
          // );
          let formatList = this.oldInfos.brandBuildlist.slice(
            startIndex,
            endIndex
          );
          if (formatList.length == 0 && this.pagination.current > 1) {
            this.pagination.current = this.pagination.current - 1;
            const startIndex =
              (this.pagination.current - 1) * this.pagination.pageSize;
            const endIndex = startIndex + this.pagination.pageSize;
            formatList = this.oldInfos.brandBuildlist.slice(
              startIndex,
              endIndex
            );
          }
          this.dataList = formatList;
        } else {
          this.dataList = [];
          this.pagination.total = 0;
          this.pagination.current = 1;
        }
      }
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row) {
      this.$refs.addGain.init("edit", row);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    option(type) {
      if (type === 1) {
        this.$emit("upStep", this.dataList);
      } else {
        this.$emit("downStep", this.dataList);
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的品牌建设");
      } else {
        if (this.oldInfos?.id) {
          let params = {
            ids: this.selectedRowKeys.toString(),
            applyId: this.oldInfos?.id,
          };
          deleteAction(
            "/promotion/lxApplyConstruction/deleteBatch",
            params
          ).then((res) => {
            if (res.code == 200) {
              this.$message.success("批量移除成功");
              // this.pagination.current = 1;
              this.getData();
              this.selectedRowKeys = [];
              this.$forceUpdate();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          // this.pagination.current = 1;
          // console.log(this.selectedRowKeys);
          this.oldInfos.brandBuildlist = this.oldInfos.brandBuildlist.filter(
            (item) => !this.selectedRowKeys.includes(item.id)
          );
          sessionStorage.setItem("pp1", JSON.stringify(this.oldInfos));
          this.getData();
          this.selectedRowKeys = [];
        }
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.cotainer {
  .cotainerhead {
    margin: 20px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .add-btn {
      width: 100px;
      height: 30px;
      background: #2155b5;
      border-radius: 6px;
      font-weight: 400;
      color: #fff;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
  .btn-action {
    width: 100px;
    height: 30px;
    border-radius: 6px;
    font-weight: 400;
    cursor: pointer;
    line-height: 30px;
    margin-right: 10px;
    text-align: center;
  }
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>
